import { compose, mdsWidget } from 'dojo/_base/declare';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './MyBookingsForm.html?raw';
// NOTE (JS2TS): dropped dead deps — lang, aspect, on, dom-construct, dom-attr, number, date are unused in code,
// and the four moreCore imports (originally with MALFORMED paths: "moreCore/UI//HintBox", "moreCore/UI/Selectbox/SelectBox",
// "moreCore/UI//GenericDialog/GenericDialog", "moreCore/UI//MultiSelect/Multiselect") are imported but never used in
// code and MyBookingsForm.html has no data-dojo-type widgets — so they are dropped entirely.

class MyBookingsForm extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    formNodes: any = [];

    isReadOnly = true;

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.silentExceptions = true;

        this.formNodes = [
            this.inputVehicleBookingBooker,
            this.inputVehicleBookingCarPool,
            this.inputVehicleBookingStatus,
            this.inputVehicleBookingDateStart,
            this.inputVehicleBookingDateEnd,
        ];
        //this._checkReadOnly();
    }
    startup(bReload?: any): void {
        super.startup.apply(this, arguments as any);

    }



    _setValues(entity: any): void {

        this.entity = entity;
        //this.myBookingDescription.textContent = this.entity.status;

        this.inputVehicleBookingBooker.value = entity.ref_booker.DispName;
        this.inputVehicleBookingCarPool.value = entity.tmp_webtool_vehicle_car_pool;
        this.inputVehicleBookingStatus.value = entity.ref_booking_status.Name;

        domStyle.set(this.inputVehicleBookingStatus, "background-color", entity.ref_booking_status.coloration.BackColor.Hex);
        domStyle.set(this.inputVehicleBookingStatus, "color", entity.ref_booking_status.coloration.TextColor.Hex);

        this.inputVehicleBookingDateStart.value = entity.date_start;
        this.inputVehicleBookingDateEnd.value = entity.date_end;

        this.infoVehicleDetails.innerHTML = entity.tmp_webtool_vehicle_info;

        this.inputVehicleBookingNote.value = entity.Note;
    }

    _setReadOnly(bool?: any): void {

        if (typeof (bool) == "undefined") {
            bool = true;
        }

        this.isReadOnly = bool;

        this._checkReadOnly();
    }

    _checkReadOnly(): void {

        if (this.isReadOnly) {

            this.formNodes.forEach((node: any) => {
                domClass.add(node, "w3-disabled")
            });
        } else {

            this.formNodes.forEach((node: any) => {
                domClass.remove(node, "w3-disabled")
            });
        }
    }

    //_onChangeInputDateStart: function(evt){
    //    console.debug(this.inputVehicleBookingDateStart);
    //},

    //_onChangeInputDateEnd: function (evt) {
    //    console.debug(this.inputVehicleBookingDateEnd);
    //},

}
MyBookingsForm.prototype.declaredClass = 'WidgetCollection.VehicleBooking.MyBookings.MyBookingsForm';

export default mdsWidget(MyBookingsForm);
